export default "__VITE_ASSET__f930f9d4__"